import { useHistory } from 'react-router-dom';

import { cardButtonsData } from '../../../../config/cardButtonsData';
import { CardButtons } from '../../../../shared/components/CardButtons';
import { CardButtonItem } from '../../../../shared/components/CardButtons/CardButtonItem';
import { usePremium } from '../../../../shared/hooks/usePremium';
import { PageContainer } from '../../../../shared/components/PageContainer';
import { Header } from '../../../../shared/components/Header';

export function Utility() {
  const isPremium = usePremium();
  const history = useHistory();

  function handlePushOrOpenModal(route: string) {
    history.push(route);
  }

  return (
    <PageContainer>
      <Header goPush="/" title="Utilidades" />
      <CardButtons>
        {cardButtonsData.map((content) => {
          return (
            content.sectionName === 'Utilidades' &&
            content.buttons.map((button) => (
              <CardButtonItem
                key={button.name}
                name={button.name}
                premiumContent={!!button?.isPremiumRequired}
                isDisabled={button?.isPremiumRequired === true && !isPremium}
                isLoading={isPremium === undefined}
                isNew={button.isNew}
                icon={button.icon}
                onClick={() => handlePushOrOpenModal(button.toPage)}
              />
            ))
          );
        })}
      </CardButtons>
    </PageContainer>
  );
}
